
let CONFIG = {};

switch (process.env.NODE_ENV) {
	case 'production':
		Object.assign(CONFIG, { baseUrl: 'https://kratos.site'});
		break;
	default:
		Object.assign(CONFIG, { baseUrl: 'http://localhost:4000'});
		break;
}

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config.js